<template>
  <div
    id="app"
    :class="cssClass">
    <content-stage/>
    <top-header/>
    <main-nav-stage/>
    <main-nav-stage-mobile-p/>
    <load-anim />
  </div>
</template>

<script>
    import TopHeader from './components/TopHeader'
    import ContentStage from './components/ContentStage'
    import MainNavStageMobileP from './components/MainNavStageMobileP'
    import MainNavStage from './components/MainNavStage'
    import LoadAnim from './components/LoadAnim'

    import EventBus from './event-bus'
    import SiteStructure from './components/tools/site-structure'
    import BodyBG from './components/tools/body-bg'

    class BackgroundManager {
      constructor () {
        this.data = {
          cssClass: ''
        }
      }
      changeContent (navItem) {
        this.data.cssClass = navItem.content
      }
    }
    const bgManager = new BackgroundManager()

    let secretKeys = ''

    export default {
      name: 'App',
      components: {
        TopHeader,
        ContentStage,
        MainNavStageMobileP,
        MainNavStage,
        LoadAnim
      },
      beforeCreate () {
        // Initial State
        if (this.$store.state.isMobileOrTablet) {
          document.body.classList.add('is-mobile-or-tablet')
        } else {
          document.body.classList.add('is-desktop')
        }
        bgManager.changeContent(SiteStructure.getSelectedItem())
        BodyBG.init()
      },
      mounted () {
        // Events
        EventBus.$on('Nav.CHANGE', function (e) {
          bgManager.changeContent(e.navItem)
        })
        document.addEventListener('keyup', this.onKeyUp)
      },
      beforeDestroy () {
        document.removeEventListener('keyup', this.onKeyUp)
      },
      data () {
        return bgManager.data
      },
      methods: {
        onKeyUp (e) {
          let k = e.key.toLowerCase()
          if (k === 'n') {
            secretKeys = ''
          }
          secretKeys += k
          if (secretKeys === 'neil') {
            this.$el.classList.add('comic-sans')
            this.$forceUpdate()
          }
        }
      }
    }

</script>

<style lang="scss" src="./components/style/_reset.scss"></style>
<style lang="sass" src="./App.sass"></style>
